import { JiraIcon } from '@atlaskit/logo';
import type { ThirdPartyProductFilter } from '@atlassian/search-client/query-generator';

import { DEFAULT_CLOUD_GRAPH_COMMENT_ENTITY_ATI } from '../../../types/default-cloud-graph-comment-entity-ati';
import { DEFAULT_CLOUD_GRAPH_PROJECT_ENTITY_ATI } from '../../../types/default-cloud-graph-project-entity-ati';
import { DEFAULT_CLOUD_GRAPH_SPACE_ENTITY_ATI } from '../../../types/default-cloud-graph-space-entity-ati';
import { DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI } from '../../../types/default-cloud-graph-work-item-entity-ati';
import {
	type ThirdPartyConfig,
	type ThirdPartyConfigsWithAPIResponse,
} from '../../../types/schemas/types';
import { NounSubtypeKey, TypeFilterValueKey } from '../../../utils/filters/universalType';
import { get3PLogo, RovoLogoFromLogo } from '../../icons';
import { JiraSearchResultIcon } from '../../icons/jira/jira-search-result-icon';
import { ProductResourceTypes3P } from '../types';

export const jiraDCConfig: ThirdPartyConfig = {
	displayName: 'Jira Data Center',
	id: 'jira-dc',
	resourceType: ProductResourceTypes3P.JiraDC,
	icon: RovoLogoFromLogo(JiraIcon, 'Jira Data Center'),
	searchResultIcon: get3PLogo(JiraSearchResultIcon, 'Jira Data Center', 'large'),
	integrationAri: 'ari:cloud:platform::integration/jira-dc',
	containerTypes: ['software', 'business', 'project'],
	typeFilterConfig: new Map([
		[
			TypeFilterValueKey.Project,
			{
				entities3P: DEFAULT_CLOUD_GRAPH_SPACE_ENTITY_ATI,
				subTypes3P: [
					NounSubtypeKey.Software,
					NounSubtypeKey.Business,
					NounSubtypeKey.ServiceDesk,
					NounSubtypeKey.Project,
				],
			},
		],
		[
			TypeFilterValueKey.Issue,
			{
				entities3P: [
					...DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI,
					...DEFAULT_CLOUD_GRAPH_PROJECT_ENTITY_ATI,
				],
				subTypes3P: [NounSubtypeKey.Issue],
			},
		],
		[
			TypeFilterValueKey.Comment,
			{
				entities3P: DEFAULT_CLOUD_GRAPH_COMMENT_ENTITY_ATI,
				subTypes3P: [],
			},
		],
	]),
	filters: ['lastUpdated', 'project', 'assignee'],
	requiresOauth: true,
	isEnabled: () => true,
	displayWorkspaceNameAsProductName: true,
	fanOutConnectorSources: true,
	// For jira crawler, we want to filter by the domain of each datasource
	getSelectedDatasourceFilters: (datasource: ThirdPartyConfigsWithAPIResponse) => {
		const filters: Partial<ThirdPartyProductFilter> = {
			integrationId: datasource?.integrationAri,
			providerId: datasource?.providerId,
		};
		return filters;
	},
};
